import { DsChartsPinDataInterface } from '../interfaces/ds-charts-pin-data.interface';

/**
 * Contains the number of one pin state's occurences over time, to draw with Chart.js
 */
export class DsChartsPinData {
  /**
   * Number of occurences for given state over time. data[0] will be drawn above label[0],
   * Length of data array must be the same as the labels array
   */
  data: number[];

  /**
   * Given pin state
   */
  state: number | string;

  /**
   * Creates an instance of DsChartsPinData.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsChartsPinDataInterface) {
    this.data = jsonData.data;
    this.state = jsonData.state;
  }
}
